<template>
	<main id="access">
		<form>
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<div v-html="formText"></div>
			<input v-if="hasCode" type="tel" v-model="code" v-on:click="scrollToThisInput">
			<button v-on:click.self.stop.prevent="validateForm()" v-bind:class="isActive ? 'selected' : ''">{{properties.button && properties.button[lang]}}</button>
		</form>
	</main>
</template>

<script>
import libs from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

export default {
	name: 'accessTpl',
	data() {
		return {
			code : ''
		};
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	computed : {
		hasCode: function(){
			if(this.properties.code) return true;
			this.code = this.properties.code
			return false
		},
		isActive: function(){
			return this.properties.code == this.code;
		},
		prettyDate : function(){
			return libs.prettyDate(this.lang, 'text');
		},
		formText : function(){
			let text = this.properties.text && this.properties.text[this.lang];
			if(!text) return '';
			return '<p>'+text.split('\n').join('</p><p>')+'</p>';
		}
	},
	methods : {
		validateForm : function(){
			if(this.properties.code != this.code) return;
			return this.$emit('validateStep', this.$options.name, {
				code : this.code
			});
		},
		scrollToThisInput: function(event){
			return libs.scrollToElem(event.target);
		},
	},
	created : componentTools.created,
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#access p{
	text-align: justify;
}
#access input{
	display: inline-block;
	width: 50%;
	text-align: center;
	-webkit-text-security: disc;
}
#access button{
	display: block;
}
@media screen
and (max-width: 480px){
	#access button{
		width: 40%;
	}
}
@media screen
and(max-height: 625px)
and(min-height: 461px)
and(max-width: 480px){
	#access form button {
			margin-bottom: 20px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/access.vue